<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-sheet class="pa-4 blue-grey lighten-1">
                    <v-text-field
                        v-model="search"
                        label="Odfiltruj po fragmencie nazwy..."
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        clear-icon="mdi-close-circle-outline"
                    />
                </v-sheet>
                <v-treeview
                    :items="categories"
                    item-children="categories"
                    :search="search"
                    :filter="filter"
                    activatable
                    @update:active="onRowClicked"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from '../services/api';
import formatters from '@/mixins/formatters';
import permissions from '@/mixins/permissions';

export default {
    mixins: [
        formatters,
        permissions,
    ],
    components: {},
    data() {
        return {
            categories: [],
            loading: false,
            options: {},
            search: null,
            filter: null,
        }
    },
    methods: {
        onRowClicked(category) {
            this.$router
                .push({name: 'category-details', params: {id: category[0]}})
                .catch((error) => {
                    if (String(error).includes('Avoided redundant navigation to current location')) {
                        return;
                    }

                    throw error;
                });
        },
        load() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            api.get('/api/categories/tree')
                .then((response) => {
                    this.categories = response.data.categories;
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać drzewa kategorii.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.load();
    },
}
</script>

<style lang="css">
.v-treeview-node__content {
    cursor: pointer;
}
</style>